export const media = {
  purchase: {
    imageTitle: "購入して閲覧しますか？",
    videoTitle: "購入して再生しますか？",
    imageDescription: "ポイントを消費して画像を閲覧します。",
    videoDescription: "ポイントを消費して動画を再生します。",
    audioTitle: "購入して再生しますか？",
    audioDescription: "ポイントを消費して音声を再生します。",
    point: (args: { point: string | number }) => `${args.point}pt`,
    confirm: "購入する",
  },
  profileList: {
    title: "画像・動画一覧",
    moreCount: (args: { count: string | number }) => `+${args.count}`,
    imageItemLabel: "画像",
    videoItemLabel: "動画",
    requestLabel: "画像・動画リクエスト",
    requestModal: {
      title: "画像・動画をリクエスト",
      imageButton: "画像をリクエスト",
      videoButton: "動画をリクエスト",
    },
    requestSentImage: "画像リクエストを送信しました",
    requestSentVideo: "動画リクエストを送信しました",
    requestCooldown: "同じ人に連続でリクエストはできません。",
  },
  /**
   * 動画終了の先回り購入モーダル（画像動画ルート）。
   * 2 本目の動画を見終わって次の 1 本が開けなくなった新規に、届いている未開封の動画を
   * サムネで見せる。「ポイントを買ってください」ではなく「まだ届いている」ことを伝える。
   */
  pointShortagePrompt: {
    /** 見出し。N は未開封の動画数（取得上限に達していれば「以上」を付ける） */
    title: (args: { count: string | number }) =>
      `届いた動画があと${args.count}本`,
    titleOverflow: (args: { count: string | number }) =>
      `届いた動画があと${args.count}本以上`,
    /** CTA: 課金ではなく「続けて見る」を約束する言い回しにする */
    cta: "続けて見る",
    /** CTA 下の注記。1 本あたりに要るポイントを正直に添える */
    ctaNote: (args: { pointsPerVideo: string | number }) =>
      `${args.pointsPerVideo}pt/本 が必要です`,
    close: "閉じる",
    thumbAlt: (args: { name: string | number }) => `${args.name}さんの動画`,
    age: (args: { age: string | number }) => `${args.age}歳`,
    /** グリッドのアクセシブルな名前 */
    listLabel: "届いている未開封の動画",
    /** 見出しの上の導入 */
    lead: "まだ見ていない",
    /** 右上のリンク: 購入せずにギャラリー（未開封タブ）へ */
    openList: "一覧で見る",
    /** 先頭のサムネが直前に見た女性の動画のときのバッジ */
    lastPartnerBadge: "いま見た人",
  },
  /**
   * 「他の動画を見る」先回りシート（画像動画ルート、1 本目で止まった人）。
   * 1 本目の動画のあと 130pt 残したままアプリにとどまっている新規に、届いている未開封の動画を
   * サムネで見せる。見た目は動画終了のモーダルと同じシートで、文言だけ差し替える。
   * ポイントは足りている人なので購入は出さず、押すとギャラリーへ移り、同じ購入確認を経て再生する。
   */
  nextVideoPrompt: {
    /** 見出し。本数は出さない（2026-10-01 ユーザー指定） */
    title: (_args: { count: string | number }) => "あなただけに届いた動画",
    titleOverflow: (_args: { count: string | number }) =>
      "あなただけに届いた動画",
    /** CTA: 先頭の動画の購入確認へ進む */
    cta: "他の動画を見る",
    /** CTA 下の注記。いまの残高で見られることを添える */
    ctaNote: (args: { pointsPerVideo: string | number }) =>
      `1本${args.pointsPerVideo}pt・いまのポイントで見られます`,
    thumbAlt: (args: { name: string | number }) => `${args.name}さんの動画`,
    age: (args: { age: string | number }) => `${args.age}歳`,
    listLabel: "届いている未開封の動画",
    /** 見出しの上の導入 */
    lead: "まだ見ていない",
    openList: "一覧で見る",
    /** 先頭のサムネが 1 本目に見た女性の動画のときのバッジ */
    lastPartnerBadge: "さっき見た人",
    /** 右上の ✖（閉じるボタン）の読み上げ名 */
    close: "閉じる",
  },
  /**
   * 動画の先回りシート（動画終了の購入モーダル・「他の動画を見る」シート）を何も押さずに閉じた人に、
   * 閉じたあと出すギャラリーの場所の案内。ギャラリーの存在自体を知らない人が多いので、場所だけ伝える
   */
  galleryGuide: {
    title: "ギャラリーもあるよ",
    body: "届いた動画は マイページ ＞ ギャラリー でいつでも見れます",
    ok: "OK",
  },
} as const;
